import React from 'react';

const BannerYouTubeRT2025 = () => {

    return (
        <div className="banner banner-style-youtube">
            <div className="video-responsive">
                <iframe 
                src={`https://www.youtube.com/embed/rdqQcJeZS5A`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
                />
            </div>
        </div>
    )
}

export default BannerYouTubeRT2025;